import { useQuery } from "@tanstack/react-query";
import {
  downloadVaccination,
  getDownloadHistory,
  downloadHistory as downloadHistoryService,
} from "service";
import { toast } from "sonner";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useDownloadHistory = () => {
  const queryClient = useQueryClient();

  const {
    data: myDownloadHistory,
    isLoading: downloadHistoryLoading,
    error: downloadHistoryError,
  } = useQuery({
    queryKey: ["download-history"],
    queryFn: async () => {
      const response = await getDownloadHistory();
      return response;
    },
    enabled: true,
  });

  // download download history
  const { mutate: downloadHistory, isPending: downloadLoading } = useMutation({
    mutationFn: async (v_id: string) => {
      const response = await downloadHistoryService(v_id);
      return response;
    },
    onSuccess: (data) => {
      toast.success("Download link sent to your email");
      queryClient.invalidateQueries({
        queryKey: ["wallet"],
      });
    },
  });

  return {
    myDownloadHistory,
    isLoading: downloadHistoryLoading,
    error: downloadHistoryError,
    downloadHistory,
    downloadLoading,
  };
};
